/**
 * Constants used throughout the application for consistency.
 *
 * @enum {string}
 * @readonly
 */
export enum CONSTANTS {
	POWERED_BY = "Powered by Satisfi Labs",
	WELCOME_MESSAGE = "Welcome to the platform!",
	ERROR_MESSAGE = "Something went wrong. Please try again.",
	SENDING_MESSAGE = "Sending...",
	PLACEHOLDER_TEXT = "Ask a question",
	TAGLINE_URL = "https://satisfilabs.com/"
}
